import ClassificationIcon from "../../../../../components/ClassificationIcon";
import { Signature } from "../../../@types/rldynamicanalysis";
import { transformSignaturesRiskFactor } from "../RlCloudSandboxUtil";

export const RlCloudSandboxSignaturesGridSchema = (sortable?: boolean) => ({
  fields: [
    {
      name: "risk_factor",
      displayTitle: <ClassificationIcon style={{ marginLeft: "6px" }} />,
      component: (item: Signature) => (
        <ClassificationIcon
          riskScore={item.risk_factor}
          classificationStyle={{ margin: 0 }}
          classification={transformSignaturesRiskFactor(item.risk_factor)}
        />
      ),
      sortable,
      style: {
        width: "60px",
        minWidth: "60px"
      }
    },
    {
      name: "description",
      className: "overflow-ellipsis",
      displayTitle: "Description",
      component: (item: Signature) => item.description,
      sortable
    }
  ]
});
